import { styled } from '@material-ui/core'
import { Typography, TextField, Button as ButtonBase } from '@material-ui/core'
import { FormLabel } from '@material-ui/core'

const INPUT_WIDTH = 120
const BUTTON_WIDTH = 50

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  padding: theme.spacing(0.9, 1.6, 2, 1.6),
}))

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: theme.spacing(1.3),
}))

export const Main = styled('div')(({ theme }) => ({
  display: 'flex',
  paddingRight: theme.spacing(2),
}))

export const Label = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(1.8),
  paddingTop: theme.spacing(0.8),
}))

export const InputWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  '&:first-child': {
    marginRight: theme.spacing(1.5),
  },
}))

export const LabelWrapper = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
})

export const Input = styled(TextField)(({ theme }) => ({
  width: INPUT_WIDTH,
  '& > div': {
    borderRadius: 0,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    transitionDuration: '0.3s',
    transitionProperty: 'background-color',
  },
  '& input': {
    '-moz-appearance': 'textfield',
    padding: theme.spacing(0.8, 0.2),
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  '& :before': {
    borderBottom: `1px solid ${theme.palette.text.disabled}`,
  },
}))

export const Button = styled(ButtonBase)({
  padding: 0,
  fontSize: 10,
  lineHeight: '11px',
  width: BUTTON_WIDTH,
  textTransform: 'uppercase',
})

export const ErrorLabel = styled(FormLabel)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
}))
